import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Star, MessageSquare, Headphones } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function MerchantTestimonials({ testimonials }) {
  return (
    <div data-testid="merchant-testimonials-section">
      <div className="flex items-center gap-3 mb-6">
        <MessageSquare className="h-6 w-6 text-slate-600" />
        <h2 className="text-2xl font-bold text-slate-900">Depoimentos dos Clientes</h2>
      </div>
      {testimonials.length === 0 ? (
        <Card className="bg-white border border-slate-200">
          <CardContent className="py-12 text-center">
            <MessageSquare className="h-12 w-12 text-slate-300 mx-auto mb-3" />
            <p className="text-slate-500">Ainda nenhum depoimento sobre seus cupons.</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {testimonials.map(t => (
            <Card key={t.validation_id} className="bg-white border border-slate-200 hover:shadow-md transition-shadow" data-testid={`testimonial-${t.validation_id}`}>
              <CardContent className="pt-6">
                <div className="flex items-center gap-3 mb-3">
                  {t.user_picture ? (
                    <img src={t.user_picture} alt="" className="w-10 h-10 rounded-full object-cover" />
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-slate-200 flex items-center justify-center">
                      <span className="text-slate-500 font-bold text-sm">{(t.user_name || 'U')[0]}</span>
                    </div>
                  )}
                  <div>
                    <p className="font-semibold text-slate-900 text-sm">{t.user_name || 'Usuario'}</p>
                    <div className="flex gap-0.5">
                      {[1, 2, 3, 4, 5].map(s => (
                        <Star key={s} className={`h-3.5 w-3.5 ${s <= t.rating ? 'fill-amber-400 text-amber-400' : 'text-slate-200'}`} />
                      ))}
                    </div>
                  </div>
                </div>
                <p className="text-slate-700 text-sm leading-relaxed mb-2">"{t.testimonial}"</p>
                {t.coupon && <Badge className="bg-slate-100 text-slate-700 border-slate-200 text-xs">{t.coupon.title}</Badge>}
                <p className="text-xs text-slate-400 mt-2">{new Date(t.validated_at).toLocaleDateString('pt-BR')}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}

export function MerchantAudiobooks({ audiobooks }) {
  return (
    <div data-testid="merchant-audiobook-section">
      <div className="flex items-center gap-3 mb-6">
        <Headphones className="h-6 w-6 text-indigo-600" />
        <h2 className="text-2xl font-bold text-slate-900">AudioBook - Estrategia e Marketing</h2>
      </div>
      {audiobooks.length === 0 ? (
        <Card className="bg-white border border-slate-200">
          <CardContent className="py-12 text-center">
            <Headphones className="h-12 w-12 text-slate-300 mx-auto mb-3" />
            <p className="text-slate-500">Nenhum audiobook disponivel ainda.</p>
            <p className="text-xs text-slate-400 mt-1">Os conteudos serao publicados pelo administrador</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {audiobooks.map(ab => (
            <Card key={ab.audiobook_id} className="bg-white border border-slate-200 hover:shadow-md transition-shadow" data-testid={`audiobook-${ab.audiobook_id}`}>
              <CardContent className="pt-5">
                <div className="flex items-start gap-3">
                  <div className="bg-indigo-100 p-3 rounded-lg shrink-0"><Headphones className="h-6 w-6 text-indigo-600" /></div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-bold text-slate-900 mb-1">{ab.title}</h3>
                    <p className="text-xs text-slate-400 mb-3">Publicado em {new Date(ab.uploaded_at).toLocaleDateString('pt-BR')}</p>
                    <video controls className="w-full rounded-lg" preload="metadata">
                      <source src={`${BACKEND_URL}/api/audiobooks/stream/${ab.filename}`} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
